import { DotsThreeCircle } from '@phosphor-icons/react';

export default DotsThreeCircle;
